



























































































import { Component, Vue, Inject, Prop, Emit } from 'vue-property-decorator'
import AbpBase from '../../../lib/abpbase'
import Util from '@/lib/util'
@Component({})
export default class SidebarMenu extends AbpBase {
  name: string = 'sidebarMenu'
  @Prop({ type: Array })
  menuList: Array<any>
  @Prop({ type: Number })
  iconSize: number
  @Prop({ type: String, default: 'dark' })
  menuTheme: string
  @Prop({ type: Array })
  openNames: Array<string>
  itemTitle(item: any): string {
    return this.L(item.meta.title)
  }
  get menuListFilter() {
    let menuList = JSON.parse(JSON.stringify(this.menuList))
    let list = menuList.filter((item) => {
      // console.log('adfasdf sd', item)
      // if(item.children && item.children.length > 0) {
      //   let child = item.children.filter(child => {
      //     console.log(child.meta, Util.abp.auth.hasPermission(child.permission));
      //     if(!child.hidden && Util.abp.auth.hasPermission(child.permission)) {
      //       return child
      //     }
      //   })
      //   item.children = child
      // }
      console.log('获取左侧列表', Util.abp.auth.hasPermission(item.permission));
      if (Util.abp.auth.hasPermission(item.permission)) {
        return item
      } else if (item.permission === '' && !item.hidden) {
        return item
      }
      // if (!item.hidden) {
      //   return item
      // }
    })
    return list
  }
  @Emit('on-change')
  changeMenu(active: string) {}
  updated() {
    this.$nextTick(() => {
      if (this.$refs.sideMenu) {
        ;(this.$refs.sideMenu as any).updateActiveName()
      }
    })
  }
}
